import Vue from "vue";
import VueI18n from "vue-i18n";
import productivityMonitoring from "./productivity-monitoring";
import common from "./common";
import assets from "./assets";
import dataLossPrevention from "./data-loss-prevention";
import settings from "./settings";
import authLayout from "./auth-layout";
import coreHr from "./core-hr";
import validation from "./validation";

Vue.use(VueI18n);
const messages = {
  en: {
    ...productivityMonitoring.en,
    ...common.en,
    ...assets.en,
    ...dataLossPrevention.en,
    ...settings.en,
    ...authLayout.en,
    ...coreHr.en,
    ...validation.en,
  },
  sp: {
    ...productivityMonitoring.sp,
    ...common.sp,
    ...assets.sp,
    ...dataLossPrevention.sp,
    ...settings.sp,
    ...authLayout.sp,
    ...coreHr.sp,
    ...validation.sp,
  },
};

const i18n = new VueI18n({
  locale: localStorage.getItem("language") || "en",
  fallbackLocale: "en",
  messages,
});

export default i18n;
